<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.6465 14.8536L5.64652 9.85359L5.29297 9.50004L5.64652 9.14648L10.6465 4.14648L11.3536 4.85359L7.20718 9.00004H12.5008C16.0908 9.00004 19.001 11.9103 19.0008 15.5003L19.0006 22.0001L18.0006 22L18.0008 15.5003C18.0009 12.4626 15.5385 10 12.5008 10H7.20718L11.3536 14.1465L10.6465 14.8536Z"
      fill="currentColor"
    />
  </svg>
</template>
